import { apiClient } from './apiService';
import { AllergenOption } from '@/types/CompanyProduct.interface';
import { PUBLIC_ALLERGENS } from './endpoints';

// Katalog sabittir (Türk Gıda Kodeksi Ek-1); oturum boyunca bir kez çekilir.
let catalogPromise: Promise<AllergenOption[]> | null = null;

export const allergenService = {
  async getAllergens(): Promise<AllergenOption[]> {
    if (!catalogPromise) {
      catalogPromise = apiClient
        .get<AllergenOption[]>(PUBLIC_ALLERGENS)
        .then((response) => response.data)
        .catch((error) => {
          catalogPromise = null; // hata durumunda sonraki çağrı tekrar denesin
          throw error;
        });
    }
    return catalogPromise;
  },

  /** Kod → Türkçe ad sözlüğü (rozet/tooltip gösterimleri için) */
  async getLabelMap(): Promise<Record<string, string>> {
    const list = await this.getAllergens();
    return Object.fromEntries(list.map((a) => [a.code, a.name]));
  }
};
